import self from "../img/self.png";
// import mock1 from "../img/mock1.png";
// import mock2 from "../img/mock2.png";
// import mock3 from "../img/mock3.png";
// import mock4 from "../img/mock4.png";
// import mock5 from "../img/mock5.png";

// Hi there! Thanks for checking out my portfolio template. Be sure to read the comments to get a better understanding of how to make this template work best for you!

export let colors = ["#00FFA4", "#A668FF"];
// I highly recommend using a gradient generator like https://gradientgenerator.paytonpierce.dev/ to generate a pair of colors that you like.
// These colors will be used to style your name on the homepage, the background of your picture, and some other accents throughout the site.

// So let's get started! Some of the info below is pretty self-explanatory, like 'firstName' and 'bio'.
// I'll try to explain anything that might not be obvious right off the bat :)
// I recommend looking at the template example live using "npm start" to get an idea of what each of the values mean.

export const info = {
  firstName: "Berkant",
  lastName: "Aslan",
  initials: "Berkant Aslan", // the example uses first and last, but feel free to use three or more if you like.
  position: "Yapay Zeka ve Dijital Dönüşüm Mühendisi",
  selfPortrait: self, // don't change this unless you want to name your self-portrait in the "img" folder something else!
  gradient: `-webkit-linear-gradient(135deg, ${colors})`, // don't change this either
  baseColor: colors[0],
  miniBio: [
    { emoji: "☕", text: "Filtre Kahve ile beslenir" },
    { emoji: "🌎", text: "Türkiye'de yaşıyor" },
    { emoji: "💼", text: "Sanver'de Yapay Zeka ve Dijital Dönüşüm Mühendisi" },
    { emoji: "📧", text: "hello@berkantaslan.com" },
  ],
  socials: [
    {
      link: "https://www.linkedin.com/in/berkantaslan/",
      icon: "fa fa-linkedin",
      label: "linkedin",
    },
    {
      link: "https://github.com/berkantaslan",
      icon: "fa fa-github",
      label: "github",
    },
    {
      link: "https://www.kaggle.com/berkantaslan",
      icon: "kaggle-svg",
      label: "kaggle",
    },
    {
      link: "https://www.instagram.com/berkant.aslan/",
      icon: "fa fa-instagram",
      label: "instagram",
    },
    {
      link: "https://www.academia.edu/attachments/134448546/download_file",
      icon: "fa fa-file-pdf-o",
      label: "cv",
    },
    {
      link: "mailto:hello@berkantaslan.com",
      icon: "fa fa-envelope",
      label: "email",
    },
    // Feel free to remove any of these that you don't have.
    // I'll write an FAQ on how to add new ones later, let me know if you have a request for an icon!
    // Just change the links so that they lead to your social profiles.
  ],
  bio: "Merhaba, Her konuda kendimi geliştirmek isteyen, projelere, genel kültüre ve yabancı dile çok önem veren biriyim. Sosyal, takım çalışmalarına uyumlu, yöneticilik vasıf ve deneyimlerine sahip, analitik ve yaratıcı düşünebilen, çok kolay ve hızlı öğrenebilen, akademik makaleler konusunda tecrübe sahibi ve akademik hedefleri olan, enerjik ve sonuç odaklı, yazmayı ve üretmeyi seven, dürüst, saygılı, sevgili, hareketli, cesur, çalışkan, mücadeleci ve vefalı bir kişiliğe sahibim. Yapay Zeka, Veri Bilimi, Büyük Veri, Görüntü İşleme ve İş Zekası ile ilgili yeteneklerimde gelişim ve öğrenimlerim devam etmektedir. İnsanları çok seven, insanlığa kendisini adamış, Türkiye aşığı, saygılı ve sevgili, eşini çok seven evli birisi..",
  skills: {
    proficientWith: [
      "python",
      "mongodb",
      "react",
      "javascript",
      "html5",
      "css3",
      "c#",
      "c",
      "c++",
      "r",
    ],
    exposedTo: [".net"],
  },
  hobbies: [
    { label: "Kitap ve Dergi Okumak", emoji: "📖" },
    { label: "Dizi ve Film İzlemek", emoji: "🎥" },
    { label: "Teknolojiyi Takip Etmek", emoji: "🚀" },
    { label: "Resim Çizmek", emoji: "🖌️" },
    { label: "Müzik Dinlemek", emoji: "🎧" },
    { label: "Futbol", emoji: "⚽" },
    { label: "Ayak Tenisi", emoji: "⚽" },
    { label: "Yüzme", emoji: "🏊" },
    { label: "Koşu", emoji: "🏃" },
    { label: "Bisiklet", emoji: "🚴" },
    { label: "Yemek Yapmak", emoji: "🍳" },
    { label: "Seyahat", emoji: "✈️" },
    { label: "Doğa Yürüyüşü", emoji: "🥾" },
    { label: "Astronomi", emoji: "🔭" },
    { label: "Girişimcilik", emoji: "💡" },
    // Same as above, change the emojis to match / relate to your hobbies or interests.
    // You can also remove the emojis if you'd like, I just think they look cute :P
  ],
  portfolio: [
    // This is where your portfolio projects will be detailed
    /*{
      title: "Project 1",
      live: "https://paytonpierce.dev", //this should be a link to the live version of your project, think github pages, netlify, heroku, etc. Or your own domain, if you have it.
      source: "https://github.com/paytonjewell", // this should be a link to the **repository** of the project, where the code is hosted.
      image: mock1
    },
    {
      title: "Project 2",
      live: "https://paytonpierce.dev",
      source: "https://github.com/paytonjewell",
      image: mock2
    },
    {
      title: "Project 3",
      live: "https://paytonpierce.dev",
      source: "https://github.com/paytonjewell",
      image: mock3
    },
    {
      title: "Project 4",
      live: "https://paytonpierce.dev",
      source: "https://github.com/paytonjewell",
      image: mock4
    },
    {
      title: "Project 5",
      live: "https://paytonpierce.dev",
      source: "https://github.com/paytonjewell",
      image: mock5
    }*/
  ],
};
